"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var _1_1 = __importDefault(require("./1"));
var _11_1 = __importDefault(require("./11"));
var _9_1 = __importDefault(require("./9"));
exports.default = (function (transparent48) { return function (frameType, data) {
    var frame = [];
    switch (frameType) {
        case 1:
            frame = _1_1.default(transparent48)(data);
            break;
        case 9:
            frame = _9_1.default(transparent48)(data);
            break;
        case 11:
            frame = _11_1.default(transparent48)(data);
            break;
        case 5: // 设备上报详情
        default:
            break;
    }
    var checkCode = frame.reduce(function (val, b) { return val + utils_1.hexToDec(b); }, 0);
    frame.push(utils_1.decToHex(checkCode).slice(-2));
    return frame.join('');
}; });



// WEBPACK FOOTER //
// ./src/transparent48v2/encode/index.ts